import { getSearchParamsString } from '@reapitform/utils'
import { useAdminGet } from '@reapitform/hooks'
import { TTablePagination } from '@reapitform/common-ui'
import { AdminFormListItem, AdminFormsListParams, IResponseWithPagination } from '../types'

export const ADMIN_FORMS_QUERY_KEY = ['admin-forms-list']

/**
 * Fetches the paged list of form definitions from the Admin API. Empty filter values are omitted from
 * the query string. Returns the flattened `_embedded` list plus table-ready pagination.
 *
 * A large default page size is used so the dashboard has the full set for grouping form-type counts and
 * client-side search/filter; this will move server-side once the list DTO gains version metadata.
 */
export const useAdminFormsList = (params: AdminFormsListParams = {}) => {
  const searchParams = getSearchParamsString({
    pageNumber: params.pageNumber ?? 1,
    pageSize: params.pageSize ?? 100,
    formType: params.formType || undefined,
    region: params.region || undefined,
    country: params.country || undefined,
  })
  const path = `/api/forms${searchParams}`

  const [result, loading, errorString, refresh] = useAdminGet<IResponseWithPagination<AdminFormListItem>>({
    path,
    retry: false,
    queryKeys: ADMIN_FORMS_QUERY_KEY,
  })

  const data = result?._embedded ?? null

  const pagination: TTablePagination | undefined = result?._embedded
    ? {
        currentPage: result.pageNumber,
        totalPage: result.totalPageCount,
        dataCount: result.totalCount,
      }
    : undefined

  return { data, pagination, loading, errorString, refresh }
}
